var _path, _rect, _g, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKundenlogoRtl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 90,
    viewBox: "0 0 180 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5H172C176.142 0.5 179.5 3.85786 179.5 8V82C179.5 86.1421 176.142 89.5 172 89.5H8C3.85786 89.5 0.5 86.1421 0.5 82V8Z",
    stroke: "#F3F0E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_972_650",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 179,
    height: 88
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 179,
    height: 88,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_972_650)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.121 30H165V60H118.121V30ZM135.945 36.8948H132.69V53.1011H150.431V49.9058H135.945V36.8948Z",
    fill: "#F3F0E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.562 30H113.441V60H66.562V30ZM80.1324 40.0902H88.3712V53.1048H91.6289V40.0902H99.8676V36.8948H80.1324V40.0902Z",
    fill: "#F3F0E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 30H61.8789V60H15V30ZM40.8074 36.8948H28.3154V53.1048H31.5699V47.433H38.102L43.8602 53.1048H48.56L42.4347 47.2223C45.1401 46.7819 46.7277 44.9039 46.7277 42.1037C46.7277 38.8406 44.6109 36.8948 40.8074 36.8948ZM43.3707 42.1489C43.3707 43.6543 42.395 44.3958 40.3808 44.3958V44.392H31.5699V39.9246H40.3808C42.395 39.9246 43.3707 40.6434 43.3707 42.1489Z",
    fill: "#F3F0E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKundenlogoRtl);
export default __webpack_public_path__ + "static/media/kundenlogo-rtl.8214d556cc1d32017d5c2ee209004f1c.svg";
export { ForwardRef as ReactComponent };